import React, {useState, useEffect} from 'react';
import {Route} from 'react-router-dom';
import Layout from '../Layout/Layout';
import QuestionSection from './QuestionSection/QuestionSection';
import Roadmap from './Roadmap/Roadmap';
import {QuestionAnswers} from '../../context';
import Questions from '../../stacks/questions/QuestionsAWS';
import QuestionsAndSections from './QuestionsAndSections';
import {useErrorToast} from '../../hooks/useErrorToast';

const QuestionnaireScreen = props => {

  const [answers,setAnswers] = useState({});
  const [rawSections,setRawSections] = useState([]);
  const [sections,setSections] = useState([]);
  const [loading,setLoading] = useState(true);
  const {setErrorMsg,errorToast} = useErrorToast('');
  const [version, setVersion] = useState(undefined);
  const [error, setError] = useState('')

  const product = props.product
  const layoutProduct = props.layoutProduct 
  const dataStore = props.dataStore
  const pathBase = props.pathBase
  const progresses = props.progresses
  const home = props.home


  useEffect(() => {
    setErrorMsg(error)
  }, [error, setErrorMsg])

  useEffect( () => {
    async function fetchData() {
      let ans = {}
      try {
        ans = await dataStore.retrieve(product)
        setAnswers({...ans})
      } catch (err) {
        console.log("Answers retreive failed: ", JSON.stringify(err, null, 2));
        setError(`Answers retreive failed:  ${JSON.stringify(err,null,2)}`);
      }

      try {
        const apiQuestions = Questions.getInstance()
        const questions = await apiQuestions.retrieve(product);
        const version = questions.find(({control}) => {
          if (control === 'version') {
            return true
          }
          return false
        })
        if (version !== undefined) {
          console.log(`Version: ${version.key}`)
          setVersion(version.key)
        }
        const sectionList = QuestionsAndSections(questions, ans)
        
        setRawSections(sectionList)
        setLoading(false);
      } catch (err) {
        setError(`Questions retreive failed: ${JSON.stringify(err,null,2)}`);
        setLoading(false);
        console.log("Questions retreive failed: ", JSON.stringify(err, null, 2));
      }
    }
    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  function repeatedSection(section, generation, sectionList) {
    for (let item of generation) {
      const sectionCopy = {}
      Object.assign(sectionCopy, section)
      sectionCopy.key += item.suffix
      sectionCopy.repeat += item.suffix
      sectionCopy.keyIndex = item.suffix
      sectionCopy.title = `${sectionCopy.title} - ${item.name}`
      sectionCopy.questions = []
      for (let question of section.questions) {
        const questionCopy = {}
        Object.assign(questionCopy, question)
        questionCopy.key = `${questionCopy.key}${item.suffix}`
        if (question.type === 'valueunit') {
          questionCopy.reference = `${questionCopy.reference}${item.suffix}`
        }
        sectionCopy.questions.push(questionCopy)
      }
      sectionList.push(sectionCopy)               
    }
  }

  // repeatParm => "countVariable" || "countVariable:P" || "countVariable,countVariable ..." || "countVariable:S,countVariable:P ..."
  // nameparm => undefined || "nameVariable" || "nameVariable, nameVariable ..."
  // returns: [{ prefix: "P", suffix: "-P0",name: "Some name" }] only suffix is required
  // returns: [{ suffix: "-0" }]

  useEffect(() => {
    function generateRepeatedSections(repeatParm, namesParm) {
      let values = []
      const nameVariable = namesParm ? namesParm.split(',') : undefined
  
      const repeats = repeatParm.split(',')
      for (let i=0; i < repeats.length; ++i) {
        const repeat = repeats[i]
        let [countVariable, prefix] = repeat.split(':')
        countVariable = countVariable.trim()
        const prefixUse = prefix ? prefix.trim() : ''
        let repeatCount = answers[countVariable]
        
        for (let j=0; j < repeatCount; ++j) {
          let value = {}
          let suffix = `-${prefixUse}${j}`
          value.prefix = prefix
          value.suffix = suffix
          if (nameVariable) {
            let fullNameVariable = `${nameVariable[i]}${suffix}`
            let name = answers[fullNameVariable]
            value.name = name ? name : `${j+1}`
          }
          values.push(value)
        }
      }
      return values
    }
  
    const sectionList = []
    for (let section of rawSections) {
      const condition = section.condition
      if (condition === undefined
       || answers[condition.lhs] === condition.rhs ) {
        if (section.repeat !== undefined) {
          const generation = generateRepeatedSections(section.repeat, section.choices)
          repeatedSection(section, generation, sectionList)
        } else {
          const sectionCopy = {}
          Object.assign(sectionCopy, section)
          sectionCopy.keyIndex = ''
          sectionList.push(sectionCopy)           
        }
      }
    }
    setSections(sectionList)
  }, [rawSections, answers])

  if (sections.length === 0) {
    return <div></div>
  }

  return (
    <Layout product={layoutProduct}>
      <QuestionAnswers.Provider value={answers}>
        <Route
          exact path={`/${pathBase}`}
          render={props => (
            <Roadmap
              sections={sections}
              answers={answers}
              loading={loading}
              // progress={progressBySection}
              history={props.history}
              // questionsBySection={questionsBySection}
              // questionsBySection={sections}
              product={product}
              layoutProduct={layoutProduct}
              dataStore={dataStore}
              pathBase={pathBase}
              progresses={progresses}
              home={home}
            />
          )}
        />
        <Route
          path={`/${pathBase}/:section`}
          render={props => (
            <QuestionSection
              {...props}
              sections={sections}
              // questionnaire={questions}
              setAnswers={setAnswers}
              answers={answers}
              version={version}
              product={product}
              layoutProduct={product}
              dataStore={dataStore}
              pathBase={pathBase}
            />
          )}
        />
      </QuestionAnswers.Provider>
      {errorToast}
    </Layout>
  );
};

export default QuestionnaireScreen;
